export default __webpack_public_path__ + "fonts/nexa-bold.otf";